import { c as _c } from "react/compiler-runtime";
import AlertComponent, { AlertType } from '@spa/components/alert/alert.component';
import FormGroupComponent, { InputType, SelectOption } from '../../form-group/form-group.component';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import React, { ReactElement, useState } from 'react';
import ButtonComponent from '../../button/button/button.component';
import { ButtonType } from '../../button/types/ButtonType';
import { CountryEntry } from '@spa/components/forms/CountryEntry';
import { InputMode } from '@spa/components/form-group/InputMode';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { ToyCatalogFormFields } from '@spa/components/toy-catalog/toyCatalogTypes';
import styles from './toy-catalog-form.component.module.scss';
import { titlesOptions } from '@spa/lib/converters/convertCustomerTitles';
import useCountries from '@spa/components/forms/useCountries';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface Props {
  readonly errors: FormikErrors<ToyCatalogFormFields>;
  readonly isSubmitting: boolean;
  readonly touched: FormikTouched<ToyCatalogFormFields>;
  readonly values: ToyCatalogFormFields;
  readonly submitError?: string;
  readonly userId?: string;
}
function ToyCatalogFormComponent(t0) {
  const $ = _c(124);
  const {
    errors,
    isSubmitting,
    touched,
    values,
    submitError
  } = t0;
  const countries = useCountries();
  const {
    formatMessage
  } = useNamespacedIntl("toy-catalog");
  const {
    formatMessage: formsFormatMessage
  } = useNamespacedIntl("forms");
  const {
    formatMessage: titleCodesFormatMessage
  } = useNamespacedIntl("title-codes");
  const [showUserNotLoggedInInfo, setShowUserNotLoggedInInfo] = useState(false);
  const {
    setTouched,
    validateForm,
    handleSubmit
  } = useFormikContext();
  let t1;
  if ($[0] !== formsFormatMessage) {
    t1 = formsFormatMessage("fields.gender");
    $[0] = formsFormatMessage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = values.salutation;
  const t3 = errors.salutation;
  const t4 = touched.salutation;
  let t5;
  if ($[2] !== titleCodesFormatMessage) {
    t5 = titlesOptions.map(titleOption => ({
      value: titleOption.value,
      name: titleOption.name ? titleCodesFormatMessage(titleOption.name) : ""
    }));
    $[2] = titleCodesFormatMessage;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== errors.salutation || $[5] !== isSubmitting || $[6] !== t1 || $[7] !== t5 || $[8] !== touched.salutation || $[9] !== values.salutation) {
    t6 = <div className={styles["toy-catalog-form__salutation"]}><FormGroupComponent id="toy-catalog-form" name="salutation" label={t1} value={t2} error={t3} touched={t4} type="select" selectOptions={t5} isDisabled={isSubmitting} /></div>;
    $[4] = errors.salutation;
    $[5] = isSubmitting;
    $[6] = t1;
    $[7] = t5;
    $[8] = touched.salutation;
    $[9] = values.salutation;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== formsFormatMessage) {
    t7 = formsFormatMessage("fields.firstName");
    $[11] = formsFormatMessage;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== errors.firstName || $[14] !== isSubmitting || $[15] !== t7 || $[16] !== touched.firstName || $[17] !== values.firstName) {
    t8 = <FormGroupComponent id="toy-catalog-form" name="firstName" label={t7} value={values.firstName} error={errors.firstName} touched={touched.firstName} type={InputType.TEXT} autoComplete="given-name" isDisabled={isSubmitting} required={true} />;
    $[13] = errors.firstName;
    $[14] = isSubmitting;
    $[15] = t7;
    $[16] = touched.firstName;
    $[17] = values.firstName;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== formsFormatMessage) {
    t9 = formsFormatMessage("fields.lastName");
    $[19] = formsFormatMessage;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== errors.lastName || $[22] !== isSubmitting || $[23] !== t9 || $[24] !== touched.lastName || $[25] !== values.lastName) {
    t10 = <FormGroupComponent id="toy-catalog-form" name="lastName" label={t9} value={values.lastName} error={errors.lastName} touched={touched.lastName} type={InputType.TEXT} autoComplete="family-name" isDisabled={isSubmitting} required={true} />;
    $[21] = errors.lastName;
    $[22] = isSubmitting;
    $[23] = t9;
    $[24] = touched.lastName;
    $[25] = values.lastName;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t8) {
    t11 = <div className={styles["toy-catalog-form__name-group"]}>{t8}{t10}</div>;
    $[27] = t10;
    $[28] = t8;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== formsFormatMessage) {
    t12 = formsFormatMessage("fields.email");
    $[30] = formsFormatMessage;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== errors.email || $[33] !== isSubmitting || $[34] !== t12 || $[35] !== touched.email || $[36] !== values.email) {
    t13 = <FormGroupComponent id="toy-catalog-form" name="email" label={t12} value={values.email} error={errors.email} touched={touched.email} type={InputType.EMAIL} autoComplete="email" isDisabled={isSubmitting} required={true} />;
    $[32] = errors.email;
    $[33] = isSubmitting;
    $[34] = t12;
    $[35] = touched.email;
    $[36] = values.email;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== formsFormatMessage) {
    t14 = formsFormatMessage("fields.street");
    $[38] = formsFormatMessage;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== errors.street || $[41] !== isSubmitting || $[42] !== t14 || $[43] !== touched.street || $[44] !== values.street) {
    t15 = <FormGroupComponent id="toy-catalog-form" name="street" label={t14} value={values.street} error={errors.street} touched={touched.street} type={InputType.TEXT} isDisabled={isSubmitting} required={true} />;
    $[40] = errors.street;
    $[41] = isSubmitting;
    $[42] = t14;
    $[43] = touched.street;
    $[44] = values.street;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] !== formsFormatMessage) {
    t16 = formsFormatMessage("fields.houseNumber");
    $[46] = formsFormatMessage;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  let t17;
  if ($[48] !== errors.houseNumber || $[49] !== isSubmitting || $[50] !== t16 || $[51] !== touched.houseNumber || $[52] !== values.houseNumber) {
    t17 = <FormGroupComponent id="toy-catalog-form" name="houseNumber" label={t16} value={values.houseNumber} error={errors.houseNumber} touched={touched.houseNumber} type={InputType.TEXT} isShrunk={true} isDisabled={isSubmitting} required={true} />;
    $[48] = errors.houseNumber;
    $[49] = isSubmitting;
    $[50] = t16;
    $[51] = touched.houseNumber;
    $[52] = values.houseNumber;
    $[53] = t17;
  } else {
    t17 = $[53];
  }
  let t18;
  if ($[54] !== t15 || $[55] !== t17) {
    t18 = <div className={styles["toy-catalog-form__group"]}>{t15}{t17}</div>;
    $[54] = t15;
    $[55] = t17;
    $[56] = t18;
  } else {
    t18 = $[56];
  }
  let t19;
  if ($[57] !== formsFormatMessage) {
    t19 = formsFormatMessage("fields.zipCode");
    $[57] = formsFormatMessage;
    $[58] = t19;
  } else {
    t19 = $[58];
  }
  let t20;
  if ($[59] !== errors.postalCode || $[60] !== isSubmitting || $[61] !== t19 || $[62] !== touched.postalCode || $[63] !== values.postalCode) {
    t20 = <FormGroupComponent id="toy-catalog-form" name="postalCode" label={t19} value={values.postalCode} error={errors.postalCode} touched={touched.postalCode} type={InputType.TEXT} inputMode={InputMode.NUMERIC} autoComplete="postal-code" isShrunk={true} isDisabled={isSubmitting} required={true} />;
    $[59] = errors.postalCode;
    $[60] = isSubmitting;
    $[61] = t19;
    $[62] = touched.postalCode;
    $[63] = values.postalCode;
    $[64] = t20;
  } else {
    t20 = $[64];
  }
  let t21;
  if ($[65] !== formsFormatMessage) {
    t21 = formsFormatMessage("fields.city");
    $[65] = formsFormatMessage;
    $[66] = t21;
  } else {
    t21 = $[66];
  }
  let t22;
  if ($[67] !== errors.city || $[68] !== isSubmitting || $[69] !== t21 || $[70] !== touched.city || $[71] !== values.city) {
    t22 = <FormGroupComponent id="toy-catalog-form" name="city" label={t21} value={values.city} touched={touched.city} error={errors.city} type={InputType.TEXT} autoComplete="city" isDisabled={isSubmitting} required={true} />;
    $[67] = errors.city;
    $[68] = isSubmitting;
    $[69] = t21;
    $[70] = touched.city;
    $[71] = values.city;
    $[72] = t22;
  } else {
    t22 = $[72];
  }
  let t23;
  if ($[73] !== t20 || $[74] !== t22) {
    t23 = <div className={styles["toy-catalog-form__group"]}>{t20}{t22}</div>;
    $[73] = t20;
    $[74] = t22;
    $[75] = t23;
  } else {
    t23 = $[75];
  }
  let t24;
  if ($[76] !== formsFormatMessage) {
    t24 = formsFormatMessage("fields.country");
    $[76] = formsFormatMessage;
    $[77] = t24;
  } else {
    t24 = $[77];
  }
  const t25 = values.countryCode;
  const t26 = errors.countryCode;
  const t27 = touched.countryCode;
  let t28;
  if ($[78] !== countries) {
    t28 = countries.map(_temp);
    $[78] = countries;
    $[79] = t28;
  } else {
    t28 = $[79];
  }
  let t29;
  if ($[80] !== errors.countryCode || $[81] !== t24 || $[82] !== t28 || $[83] !== touched.countryCode || $[84] !== values.countryCode) {
    t29 = <FormGroupComponent id="toy-catalog-form" name="countryCode" label={t24} value={t25} error={t26} touched={t27} type="select" selectOptions={t28} isDisabled={true} required={true} />;
    $[80] = errors.countryCode;
    $[81] = t24;
    $[82] = t28;
    $[83] = touched.countryCode;
    $[84] = values.countryCode;
    $[85] = t29;
  } else {
    t29 = $[85];
  }
  let t30;
  if ($[86] !== formatMessage) {
    t30 = formatMessage("privacyPolicy");
    $[86] = formatMessage;
    $[87] = t30;
  } else {
    t30 = $[87];
  }
  let t31;
  if ($[88] !== t30) {
    t31 = <div className={styles["toy-catalog-form__privacy-policy"]} dangerouslySetInnerHTML={{
      __html: t30
    }} />;
    $[88] = t30;
    $[89] = t31;
  } else {
    t31 = $[89];
  }
  let t32;
  if ($[90] !== formatMessage) {
    t32 = formatMessage("required");
    $[90] = formatMessage;
    $[91] = t32;
  } else {
    t32 = $[91];
  }
  let t33;
  if ($[92] !== t32) {
    t33 = <span className={styles["toy-catalog-form__required-text"]}>{t32}</span>;
    $[92] = t32;
    $[93] = t33;
  } else {
    t33 = $[93];
  }
  let t34;
  if ($[94] !== formatMessage) {
    t34 = formatMessage("orderCatalog");
    $[94] = formatMessage;
    $[95] = t34;
  } else {
    t34 = $[95];
  }
  let t35;
  if ($[96] !== handleSubmit || $[97] !== setTouched || $[98] !== validateForm || $[99] !== values) {
    t35 = () => {
      const fields = Object.fromEntries(Object.keys(values).map(_temp2));
      setTouched(fields, true);
      validateForm();
      setShowUserNotLoggedInInfo(true);
      handleSubmit();
    };
    $[96] = handleSubmit;
    $[97] = setTouched;
    $[98] = validateForm;
    $[99] = values;
    $[100] = t35;
  } else {
    t35 = $[100];
  }
  let t36;
  if ($[101] !== isSubmitting || $[102] !== t34 || $[103] !== t35) {
    t36 = <div className={styles["toy-catalog-form__submit-button"]}><ButtonComponent buttonType={ButtonType.PRIMARY} text={t34} type="submit" disabled={isSubmitting} onClick={t35} /></div>;
    $[101] = isSubmitting;
    $[102] = t34;
    $[103] = t35;
    $[104] = t36;
  } else {
    t36 = $[104];
  }
  let t37;
  if ($[105] !== t33 || $[106] !== t36) {
    t37 = <div className={styles["toy-catalog-form__submit"]}>{t33}{t36}</div>;
    $[105] = t33;
    $[106] = t36;
    $[107] = t37;
  } else {
    t37 = $[107];
  }
  let t38;
  if ($[108] !== errors.userId || $[109] !== showUserNotLoggedInInfo) {
    t38 = errors.userId && showUserNotLoggedInInfo && <div className={styles["toy-catalog-form__submit-error"]}><AlertComponent alertType={AlertType.INFO} content={errors.userId} /></div>;
    $[108] = errors.userId;
    $[109] = showUserNotLoggedInInfo;
    $[110] = t38;
  } else {
    t38 = $[110];
  }
  let t39;
  if ($[111] !== submitError) {
    t39 = !!submitError && <div className={styles["toy-catalog-form__submit-error"]}><AlertComponent alertType={AlertType.ERROR} content={submitError} /></div>;
    $[111] = submitError;
    $[112] = t39;
  } else {
    t39 = $[112];
  }
  let t40;
  if ($[113] !== t11 || $[114] !== t13 || $[115] !== t18 || $[116] !== t23 || $[117] !== t29 || $[118] !== t31 || $[119] !== t37 || $[120] !== t38 || $[121] !== t39 || $[122] !== t6) {
    t40 = <div className={styles["toy-catalog-form"]}>{t6}{t11}{t13}{t18}{t23}{t29}{t31}{t37}{t38}{t39}</div>;
    $[113] = t11;
    $[114] = t13;
    $[115] = t18;
    $[116] = t23;
    $[117] = t29;
    $[118] = t31;
    $[119] = t37;
    $[120] = t38;
    $[121] = t39;
    $[122] = t6;
    $[123] = t40;
  } else {
    t40 = $[123];
  }
  return t40;
}
function _temp2(key) {
  return [key, true];
}
function _temp(t0) {
  const {
    code,
    name
  } = t0;
  return {
    name,
    value: code
  };
}
export default ToyCatalogFormComponent;